module.exports = __webpack_public_path__ + "static/009_001-0f3533345faa090d57bb848f35e416b7.jpg";